export default __webpack_public_path__ + "static/media/physiotherapist-and-boy-holding-ball-260x147.eeb6c5a4.png";